import React from "react";

import {Breadcrumbs, CssBaseline, Link, Stack, ThemeProvider, Typography} from "@mui/material";
import {lightTheme} from "./Themes";
import {Portada} from "./components/Portada";
import {TopBar} from "./components/TopBar";
import {NavigationMenu} from "./components/NavigationMenu";
import {BottomBanner} from "./components/BottomBanner";
import {Skyline} from "./components/Skyline";
import {globalMaxWidth} from "./GlobalConfigs";

function BreadcrumbSection() {
    return (
        <Breadcrumbs aria-label="breadcrumb" margin={2}>
            <Link underline="hover" color="inherit" href="/">
                Home
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Aviso Legal</Typography>
        </Breadcrumbs>
    );
}

function Contents(){
    return (
        <Stack spacing={4} sx={{
            maxWidth: globalMaxWidth,
            width: '80%'
        }}>
            <Typography variant ='h4' align='justify'>
                Datos del evento
            </Typography>
            <Link href='https://ursi.es/simposio-nacional/#simposio'>
                XLI Simposio Nacional de la Unión Científica Internacional de Radio (URSI 2026)
            </Link>
            <Typography variant ='body1' align='justify'>
                Del 2 al 4 de Septiembre de 2026
            </Typography>
            <Typography variant ='h4' align='justify'>
                Responsabilidad
            </Typography>

            <Typography variant ='body1' align='justify'>
                El siguiente organizador es responsable de los contenidos de esta instalación de ConfTool:
            </Typography>

            <Typography variant ='body1' align='justify' sx={{wordBreak: "break-word"}}>
                <strong>
                    Dirección:
                </strong>
                <pre style={{ fontFamily: 'inherit' }}>
                    {`    Camino San Francisco de Paula, nº 19. 
    Escuela Superior de Ingeniería y Tecnología. 
    Apartado 456. 
    Código postal 38200. 
    San Cristóbal de La Laguna,
    Spain. `}
                </pre>
            </Typography>

            <Typography variant ='body1' align='justify'>
                <strong> Contacto: </strong> <Link href="mailto:congresoursi2026@ull.edu.es" underline="hover" sx={{mr:1}}> congresoursi2026@ull.edu.es
                </Link>
            </Typography>

            <Typography variant ='body1' align='justify'>
                <strong>Página web:</strong> <Link href="https://ursi.es/simposio-nacional/#simposio" underline="hover" sx={{mr:1}}>
                    https://ursi.es/simposio-nacional/#simposio
                </Link>
            </Typography>

        </Stack>
    )
}

function LegalPage() {
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="App">
                <CssBaseline/>
                <Stack alignItems='center'>
                    <TopBar/>
                    <NavigationMenu/>
                    <Portada with_buttons={false} construction_text={false}/>
                    <BreadcrumbSection/>
                    <Contents/>
                    <Skyline/>
                    <BottomBanner/>
                </Stack>
            </div>
        </ThemeProvider>
    )
}

export default LegalPage;
